import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import { Tag } from "primereact/tag";
import { Message } from "primereact/message";

import { Icon, Loading, SelectableCard } from "@/ds";

import {
  BUSCAR_FORNECEDOR_PLACEHOLDER,
  DISPONIVEL_LABEL,
  FORNECEDORES_INDISPONIVEIS_MESSAGE,
  FORNECEDORES_LOAD_ERROR_MESSAGE,
  GERA_CONFLITO_LABEL,
  SUBSTITUTO_SECTION_LABEL,
} from "../../resolver-conflito-fornecedor.constants";
import styles from "./substituto-fornecedor-step.module.scss";
import type { SubstitutoFornecedorStepViewModel } from "./types-substituto-fornecedor-step";

export function SubstitutoFornecedorStepView({
  fornecedorNome,
  periodoInfo,
  search,
  erroSubstituto,
  fornecedores,
  avisoGeraConflito,
  escolherSubstituto,
  buscar,
}: SubstitutoFornecedorStepViewModel) {
  return (
    <>
      <div className={styles.resumo} data-testid="resolver-conflito-resumo-curto">
        <span>
          <strong>{fornecedorNome}</strong> • Fornecedor
        </span>
        <span className={styles.resumoInfo}>
          <i className="pi pi-info-circle" aria-hidden />
          {periodoInfo}
        </span>
      </div>

      <fieldset className={styles.secao} aria-describedby="resolver-conflito-substituto-error">
        <legend className={styles.secaoTitulo}>{SUBSTITUTO_SECTION_LABEL}</legend>
        <IconField iconPosition="left" className={styles.busca}>
          <InputIcon className="pi pi-search" />
          <InputText
            className={styles.buscaCampo}
            value={search}
            placeholder={BUSCAR_FORNECEDOR_PLACEHOLDER}
            aria-label={BUSCAR_FORNECEDOR_PLACEHOLDER}
            maxLength={100}
            onChange={(event) => buscar(event.target.value)}
            data-testid="resolver-conflito-busca"
          />
        </IconField>

        {fornecedores.tipo === "carregando" ? (
          <div className={styles.estado} data-testid="resolver-conflito-substitutos-loading">
            <span>
              <Loading size="sm" aria-hidden /> Carregando fornecedores...
            </span>
          </div>
        ) : null}

        {fornecedores.tipo === "erro" ? (
          <div
            className={styles.estado}
            role="alert"
            data-testid="resolver-conflito-substitutos-error"
          >
            {FORNECEDORES_LOAD_ERROR_MESSAGE}
          </div>
        ) : null}

        {fornecedores.tipo === "vazio" ? (
          <div
            className={styles.estado}
            role="status"
            data-testid="resolver-conflito-substitutos-empty"
          >
            {fornecedores.mensagem}
          </div>
        ) : null}

        {fornecedores.tipo === "lista" ? (
          <>
            {fornecedores.semDisponiveis ? (
              <div
                className={styles.estado}
                role="status"
                data-testid="resolver-conflito-substitutos-indisponiveis"
              >
                {FORNECEDORES_INDISPONIVEIS_MESSAGE}
              </div>
            ) : null}
            <ul
              className={`${styles.lista} ${erroSubstituto ? styles.invalida : ""}`}
              data-testid="resolver-conflito-substitutos"
            >
              {fornecedores.opcoes.map((item) => (
                <li key={item.id}>
                  <SelectableCard
                    value={item.id}
                    selected={item.marcado}
                    name="resolver-conflito-substituto"
                    onSelect={escolherSubstituto}
                    className={styles.item}
                    data-testid="resolver-conflito-substituto-option"
                  >
                    <span className={styles.itemMeta}>
                      <span className={styles.itemNome}>{item.nome}</span>
                      <span className={styles.itemPapel}>{item.detalhe}</span>
                    </span>
                    {item.geraConflito ? (
                      <Tag
                        className="p-tag-xs"
                        severity="warning"
                        icon="pi pi-exclamation-triangle"
                        value={GERA_CONFLITO_LABEL}
                      />
                    ) : (
                      <Tag className="p-tag-xs" severity="success" value={DISPONIVEL_LABEL} />
                    )}
                  </SelectableCard>
                </li>
              ))}
            </ul>
          </>
        ) : null}

        {avisoGeraConflito ? (
          <Message
            severity="warn"
            role="status"
            text={avisoGeraConflito}
            data-testid="resolver-conflito-gera-conflito"
          />
        ) : null}

        {erroSubstituto ? (
          <span
            id="resolver-conflito-substituto-error"
            className={styles.erro}
            role="alert"
            data-testid="resolver-conflito-substituto-error"
          >
            {erroSubstituto}
          </span>
        ) : null}
      </fieldset>
    </>
  );
}
